import React, { useEffect, useRef } from 'react';
import { normalizeRichTextLinksInContainer } from '@/utils/normalizeRichTextLinks';
import { useWebModalStore } from '@/hooks/useWebModalStore';

const RichTextHtmlViewer = ({
  html,
  className
}: {
  html?: string | null;
  className?: string;
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { setShowModalShowImage } = useWebModalStore();

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    normalizeRichTextLinksInContainer(container);

    container.querySelectorAll('video').forEach((video) => {
      video.controls = true;
      video.preload = 'metadata';
      video.setAttribute('playsinline', 'true');
      video.setAttribute('webkit-playsinline', 'true');
    });
  }, [html]);

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    const target = event.target;
    if (!(target instanceof HTMLImageElement)) return;

    event.preventDefault();
    event.stopPropagation();
    setShowModalShowImage(true, target.currentSrc || target.src);
  };

  if (!html) {
    return null;
  }

  return (
    <div
      ref={containerRef}
      className={className}
      onClick={handleClick}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default RichTextHtmlViewer;
